// src/pages/cpaCareerQuiz/components/StartPage.jsx
import { motion } from "framer-motion";

export default function StartPage({ onStart }) {
  return (
    <motion.fieldset
      className="start-hero"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      {/* 四角人物圖 */}
      <img src="/psytestImg/鑑識會計.png" className="hero-person p1" alt="" />
      <img src="/psytestImg/跨國職涯發展.png" className="hero-person p2" alt="" />
      <img src="/psytestImg/財務規劃與分析.png" className="hero-person p3" alt="" />
      <img src="/psytestImg/企業財務會計與報吿.png" className="hero-person p4" alt="" />

      {/* 原本上方圖片
      <div className="result-image-wrap mb-5">
        <img
          className="result-image"
          src="/psytestImg/8.png"
          alt=""
        />
      </div> */}

      <div className="title mt100">
        <h2>CPA 職涯導航：探索你的專業契合度</h2>
        <p className="w-50 m-auto mt100">
          會計專業不只有一種可能。透過 12 題情境測驗，精準分析你的性格傾向與價值觀，
          找到最能發揮你潛力的 CPA 職涯路徑！
        </p>
      </div>

      <div className="mt-4 w-75 m-auto testsubtext">
        <h2>測驗特色</h2>
        <ul className="mt-3">
          <li><b>量身打造的職涯分析：</b>針對會計系學生、四大事務所職員及轉職者設計。</li>
          <li><b>多維度深度評估：</b>從工作型態、風險容忍度到長期價值觀，進行全面剖析。</li>
          <li><b>對接國際標準：</b>結合專業觀點，讓你了解 CPA 資格如何成為你的國際通行證。</li>
          <li><b>降低選擇不確定性：</b>協助你判斷更適合分析導向的技術專家，還是商業導向的決策支援者。</li>
        </ul>
      </div>

      <div className="action-buttons mt-5 mb100">
        <button type="button" className="action-button" onClick={onStart}>
          立即開始測驗
        </button>
      </div>
    </motion.fieldset>
  );
}